import client from './client'

export const onBoardingService = {
  getIntegrationUrl,
}

function getIntegrationUrl () {
  return client.get('/api/onboarding/get-integration-url')
}



